import { render, staticRenderFns } from "./WizardStep4.vue?vue&type=template&id=57f9c0fc&"
import script from "./WizardStep4.vue?vue&type=script&lang=js&"
export * from "./WizardStep4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports